export const API_ENDPOINTS = {
  LOGIN: "/api/login",
  SIGNUP: "/api/register",
  FORGOT: "/api/forgot-password",
  LOGOUT: "/api/logout",
  CHANGE_PASSWORD: "/api/change-password",
  USER_PROFILE: "/user/profile",
  PUBLIC_POSTS: "/public/posts",
  USER_ROLES: "/api/roles",
  // navigation
  TOP_MENUS: "/api/top-menus",
  QUICK_LINKS: "/api/quick-menus",
  ABOUT_MENUS: "/api/about-menus",
  HOME_KNOWLEDGE_PARTNER_PROGRAM: "/api/home-knowledge-partner-program",
  HOME_KNOWLEDGE_SERIES: "/api/home-knowledge-series",
  HOME_TRUSTED_BY: "/api/home-trusted-by",
  HOME_FEATURE_MENTORS: "/api/home-feature-mentors",
  HOME_TESTIMONIALS: "/api/testimonials",
  HOME_COUNTERS: "/api/home-counters",
  HOME_PUBLISHING_OUTCOMES: "/api/home-publishing-outcome1",
  HOME_PUBLISHING_OUTCOMES2: "/api/home-publishing-outcome2",
  HOME_APPOINTMENTS_ANNOUNCEMENTS: "/api/home-appointments-announcements",
  HOME_QUICK_DISCOVERY: "/api/home-quick-discovery",
  HOME_AUTHOR_MEMBERS_SPOTLIGHT: "/api/home-author-members-spotlight",
  HOME_INSITUTIONAL_PARTNERS: "/api/home-institutional-partners",
  HOME_BANNER: "/api/home-banner",
  SITE_INFORMATION: "/api/site-information",
  UPDATE_INSTITUTION_PROFILE: "/api/update-institution-profile",
  UPDATE_AUTHOR_PROFILE: "/api/update-author-profile",
  UPDATE_MENTOR_PROFILE: "/api/update-mentor-profile",
  VIEW_INSTITUTION_PROFILE: "/api/view-institution-profile",
  VIEW_MENTOR_PROFILE: "/api/view-mentor-profile",
  VIEW_AUTHOR_PROFILE: "/api/view-author-profile",
  GET_COUNTRIES: "/api/countries",
  GET_STATES: "/api/countries",
  GET_INSTITUTION_LIST: "/api/get-all-institutions",
  GET_SUBJECT_EXPERTISE: "/api/get-subject-expertise",
  GET_MENTORSHIP_OFFERED: "/api/get-mentorship-offered",
  GET_MENTORS_LIST: "/api/get-all-mentors",
  GET_AUTHORS_LIST: "/api/get-all-authors",
  GET_ORGANIZATIONS: "/api/organization",
  GET_INSTITUTION_TYPE: "/api/organization",
  GET_DEPARTMENT_TYPES: "/api/department",
  GET_DEPARTMENT_FACULTY: "/api/department",
  MENTOR_SIMILAR_PROFILE: "/api/get-similar-mentors",
  AUTHOR_SIMILAR_PROFILE: "/api/get-similar-authors",

};
